export enum PriceModes {
  Fee = 'FEE',
  Margin = 'MARGIN',
}

export enum InvoiceSorterTypes {
  dueDate = 'dueDate',
  issueDate = 'issueDate',
  lastActionDate = 'lastActionDate',
  editor = 'editor',
  paidAt = 'paidAt',
  invoiceId = 'invoiceId',
  codePO = 'codePO',
  client = 'client',
  subject = 'subject',
  leadNames = 'leadNames',
  requester = 'requester',
  sender = 'sender',
  total = 'total',
}

export enum SpoSorterTypes {
  reqNumber = 'reqNumber',
  spoNumber = 'spoNumber',
  supplier = 'supplier',
  editor = 'editor',
  codePO = 'codePO',
  reviewer = 'reviewer',
  requester = 'requester',
  sentForReviewDate = 'sentForReviewDate',
  createdAt = 'createdAt',
  totalAmount = 'totalAmount',
}
